export default __webpack_public_path__ + "static/media/Image_news_dashboard_en.70403234.png";